import { useContext } from 'react'
import { AuthContext } from '@/context/auth'
import { Redirect } from 'react-router-dom'

export default function PublicGuard({ children }) {
	const [auth] = useContext(AuthContext)

	return !auth.authenticated ? children : <Redirect to='/' />
}
